module.exports = __webpack_public_path__ + "static/media/fa-regular-400.4758ad60.woff2";